import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Popper,
  Select,
  Tooltip,
} from "@mui/material";
import { createIframe, listaErrores } from "helpers/helpers";
import { useUiStore } from "hooks/useUiStore";
import { useVisorDocumentosStore } from "hooks/useVisorDocumentosStore";
import { AiFillPrinter, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { BiZoomIn, BiZoomOut } from "react-icons/bi";
import { usePromocionStore } from "../../../../hooks/usePromocionStore";
import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { BsCloudDownload } from "react-icons/bs";
import Paper from "@mui/material/Paper";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArticleIcon from "@mui/icons-material/Article";
import TopicIcon from "@mui/icons-material/Topic";
import { getObtenerTodosDocumentosPDF } from "../../../../services/actuacionesPDFService/actuacionPdfService";
import { ParamsTodosDocumentosPDF } from "../../../../interfaces/actuacionPDFservice/actuacionPDFServiceInterfaces";
import Swal from "sweetalert2";

const minScale = 1.0;
const maxScale = 4.0;

export const MenuOptions = ({
  documentoSeleccionado,
}: {
  documentoSeleccionado: string | null;
}) => {
  const formValue = localStorage.getItem("form");
  const { loadingBackdrop, addMessageSnackBmessageSnackBar } = useUiStore();
  const {
    scale,
    documentSelected,
    changeScale,
    addDocumentoSeleccionado,
    documentos,
    posicion,
    addPosicion,
    addDocumentos,
  } = useVisorDocumentosStore();
  const { darkMode } = useUiStore();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const [referencia, setReferencia] = useState<number>(0);
  const [tipoActuacion, setTipoActuacion] = useState<number>(0);
  const [nombreArchivo, setNombreArchivo] = useState<string>("");
  const { startGetFileSolicitudPromocion, promocionSelected } =
    usePromocionStore();
  const handleClickDecreaseScale = () => {
    if (window.innerWidth < 600) return;
    if (scale > minScale) changeScale(scale - 0.5);
  };

  const handleClickIncreaseScale = () => {
    if (window.innerWidth < 600) return;
    if (scale < maxScale) changeScale(scale + 0.5);
  };

  const handleSelectDocument = (value: any) => {
    if (typeof value != "object" && value?.includes("http")) {
      addDocumentoSeleccionado(value);
    } else {
      const document = { path: value?.path };
      startGetFileSolicitudPromocion(document);
    }
  };

  const handlePrintPdf = () => {
    createIframe(documentoSeleccionado);
  };
  const handleNextDocument = () => {
    const newPostion = posicion + 1;
    const nextDocument = {
      path: documentos?.[newPostion]?.path ?? documentSelected?.[newPostion],
    };
    if (
      newPostion < documentos?.length ||
      newPostion < documentSelected?.length
    ) {
      addPosicion(newPostion);
      if (nextDocument?.path?.includes("http"))
        addDocumentoSeleccionado(
          nextDocument?.path ? nextDocument?.path : nextDocument
        );
      else startGetFileSolicitudPromocion(nextDocument);
    }
  };
  const handlePreviousDocument = () => {
    const newPostion = posicion - 1;
    const nextDocument = {
      path: documentos?.[newPostion]?.path ?? documentSelected?.[newPostion],
    };
    if (
      (newPostion < documentos?.length ||
        newPostion < documentSelected?.length) &&
      newPostion >= 0
    ) {
      addPosicion(newPostion);
      if (nextDocument?.path?.includes("http"))
        addDocumentoSeleccionado(
          nextDocument?.path ? nextDocument?.path : nextDocument
        );
      else startGetFileSolicitudPromocion(nextDocument);
    }
  };

  useEffect(() => {
    return () => {
      addPosicion(0);
      addDocumentos([]);
      addDocumentoSeleccionado("");
    }; // eslint-disable-next-line
  }, []);

  //#region boton de descarga
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (formValue === "TableSolicitudPromociones" && promocionSelected) {
      setTipoActuacion(
        promocionSelected?.promocion?.tipo_actuacion_materia?.cveTipoActuacion
      );
      setReferencia(promocionSelected?.promocion?.idActuacion);
      setNombreArchivo(
        `${
          promocionSelected?.promocion?.tipo_actuacion_materia?.tipo_actuacion
            ?.descTipoActuacion ?? ""
        }  ${promocionSelected?.promocion?.numActuacion}-${
          promocionSelected?.promocion?.aniActuacion
        }`
      );
    }
    if (formValue === "Portada" && promocionSelected) {
      setTipoActuacion(promocionSelected?.cveTipoActuacion);
      setReferencia(promocionSelected?.referenciaId);
      setNombreArchivo(promocionSelected?.label);
    }
    // eslint-disable-next-line
  }, [formValue, promocionSelected]);

  const obtenerDocumento = () => {
    try {
      loadingBackdrop(true);
      addMessageSnackBmessageSnackBar("Descargando Documentos");
      // @ts-ignore
      let queryParams: ParamsTodosDocumentosPDF = {
        idReferencia: referencia,
        cveTipoActuacion: tipoActuacion,
      };
      getObtenerTodosDocumentosPDF(queryParams)
        .then((response) => {
          loadingBackdrop(false);
          const pdf = new Blob([response?.data], { type: "application/pdf" });
          const url = URL.createObjectURL(pdf);
          const a = document.createElement("a");
          a.href = url;
          a.download = nombreArchivo + ".pdf";
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch((error: any) => {
          console.log("error", error.response.data);
          Swal.fire({
            title: `¡Cuidado!`,
            text: error?.response?.data || "Hubo un problema",
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#6e7881",
            html: `
            <style>
            h4, h5{
              font-family: arial;
              color: #545454;
              text-align: center;
            }
            </style>
            <strong>  <h3>${
              error.response.data || "Hubo un problema"
            }</h3> </strong>
            <h5>${error?.response?.data || "Hubo un problema"}</h5>
            <div id="lista-errores"></div>
            `,
          });
          listaErrores(error);
          console.log("error", error);
        });
    } catch (e) {
      console.log("Error al descargar todos los documentos", e);
    }
  };

  //#endregion

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "20px",
      }}
    >
      <Grid container className={"flex ml-5 mr-5"}>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          className={"flex justify-center"}
        >
          <Tooltip title="Decrementar">
            <Avatar className="mx-4">
              <IconButton onClick={handleClickDecreaseScale}>
                <BiZoomOut />
              </IconButton>
            </Avatar>
          </Tooltip>
          <Tooltip title="Aumentar">
            <Avatar className="mx-4">
              <IconButton onClick={handleClickIncreaseScale}>
                <BiZoomIn />
              </IconButton>
            </Avatar>
          </Tooltip>
        </Grid>

        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          className={"flex justify-center"}
        >
          <Tooltip title="Documento Anterior">
            <Avatar className="mx-4">
              <IconButton
                disabled={Number(posicion + 1) === 1 ? true : false}
                onClick={() => {
                  handlePreviousDocument();
                }}
              >
                <AiOutlineLeft />
              </IconButton>
            </Avatar>
          </Tooltip>

          {formValue !== "Portada" && (
            <Tooltip
              title={`${
                formValue === "StepAdjuntarDocumentos"
                  ? "Documento 1"
                  : Number(documentos.length - 1) !== -1
                  ? `Documento ${posicion + 1}`
                  : `Sin documentos que mostrar`
              }`}
            >
              <InputText
                disabled={true}
                style={{ width: "85%" }}
                value={
                  formValue === "StepAdjuntarDocumentos"
                    ? "Documento 1"
                    : documentos.length - 1 !== -1
                    ? `Documento ${posicion + 1}`
                    : `Sin documentos que mostrar`
                }
              />
            </Tooltip>
          )}
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            placeholder="Selecciona una opción"
            className={`${darkMode === "light" ? "bg-[white]" : ""}  `}
            value={documentoSeleccionado || ""}
            size="small"
            onChange={(e) => {
              handleSelectDocument(e.target.value);
            }}
          >
            {Number(documentos.length - 1) === Number(-1) &&
            formValue === "StepAdjuntarDocumentos" ? (
              formValue === "StepAdjuntarDocumentos" ? (
                <MenuItem>Documento 1</MenuItem>
              ) : (
                <MenuItem>Sin documentos que mostrar</MenuItem>
              )
            ) : documentos.length > 0 ? (
              documentos.map((item, index) => {
                if (index < documentos.length) {
                  return (
                    <MenuItem
                      value={item}
                      key={index}
                      onClick={() => {
                        addPosicion(index);
                      }}
                    >
                      Documento {index + 1}
                    </MenuItem>
                  );
                }
                return null;
              })
            ) : documentSelected.length > 0 ? (
              documentSelected.map((item, index) => {
                if (index < documentSelected.length) {
                  return (
                    <MenuItem
                      value={item}
                      key={index}
                      onClick={() => {
                        addPosicion(index);
                      }}
                    >
                      Documento {index + 1}
                    </MenuItem>
                  );
                }
                return null;
              })
            ) : null}
          </Select>

          <Tooltip title="Siguiente Documento">
            <Avatar className="mx-4">
              <IconButton
                disabled={
                  formValue === "StepAdjuntarDocumentos"
                    ? posicion === documentos?.length
                    : posicion + 1 === documentos?.length
                }
                onClick={() => {
                  handleNextDocument();
                }}
              >
                <AiOutlineRight />
              </IconButton>
            </Avatar>
          </Tooltip>
        </Grid>

        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          className={"flex justify-center"}
        >
          {/* <Tooltip title="Print">
            <Avatar className="mx-4">
              <IconButton onClick={handlePrintPdf}>
                <AiFillPrinter />
              </IconButton>
            </Avatar>
          </Tooltip> */}
          {(formValue === "TableSolicitudPromociones" ||
            formValue === "Portada") &&
          typeof promocionSelected?.key != "number" &&
          promocionSelected?.cveTipoActuacion != null ? (
            <>
              <ButtonGroup
                variant="contained"
                ref={anchorRef}
                aria-label="Button group with a nested menu"
                style={{ backgroundColor: "#bdbdbd", color: "#575757" }}
              >
                <IconButton onClick={handleToggle}>
                  <BsCloudDownload />
                </IconButton>
                <Button
                  size="small"
                  aria-controls={open ? "split-button-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle}
                  style={{ color: "#575757", backgroundColor: "#bdbdbd" }}
                >
                  <ArrowDropDownIcon />
                </Button>
              </ButtonGroup>
              <Popper
                sx={{
                  zIndex: 1,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center bottom",
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList
                          id="split-button-menu"
                          style={{ color: "#575757" }}
                          autoFocusItem
                        >
                          <MenuItem key={"actual"} disabled={false}>
                            <a
                              href={documentoSeleccionado ?? ""}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <ArticleIcon />
                              Descargar
                            </a>
                          </MenuItem>
                          <MenuItem
                            style={{ color: "#575757" }}
                            key={"todos"}
                            disabled={false}
                            onClick={(event) => {
                              obtenerDocumento();
                            }}
                          >
                            <TopicIcon />
                            Descargar todos
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </>
          ) : (
            <Tooltip title="Descargar">
              <Avatar className="mx-4">
                <IconButton>
                  <a
                    href={documentoSeleccionado ?? ""}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    <BsCloudDownload />
                  </a>
                </IconButton>
              </Avatar>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
